import _attachInitializer from './attach-initializer';
export { _attachInitializer as attachInitializer };
export { isFunction, isString, isDefined, isNull } from './is';
export function setterName(name) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set';
  var Name = capitalize(name);
  return prefix + Name;
}
export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}